// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wave":"wave__wave__xeW3r","waveFullWidth":"wave__waveFullWidth__1mRor"};